export default __webpack_public_path__ + "static/media/srisailamVisitThree.d8de931f.jpg";